import(/* webpackMode: "eager" */ "/vercel/path0/src/app/about/our-team/page.tsx");
